import React, { useState } from 'react';
import { useStripe } from '../contexts/StripeContext';

interface PaymentButtonProps {
  priceId: string;
  label: string;
  className?: string;
}

const PaymentButton: React.FC<PaymentButtonProps> = ({ priceId, label, className }) => {
  const { loading, createCheckoutSession } = useStripe();
  const [error, setError] = useState<string | null>(null);

  const handleClick = async () => {
    setError(null);
    try {
      await createCheckoutSession(priceId);
    } catch (err) {
      console.error('Payment error:', err);
      setError('Failed to initiate payment. Please try again.');
    }
  };

  return (
    <div>
      <button
        onClick={handleClick}
        disabled={loading}
        className={`px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:bg-blue-400 ${className}`}
      >
        {loading ? 'Processing...' : label}
      </button>
      {error && <p className="text-red-500 mt-2 text-sm">{error}</p>}
    </div>
  );
};

export default PaymentButton;
